<script lang="ts">
    import SVGIcon from "$/components/SVGIcon.svelte";

    /**
     * NOTE: It is in a form of an async function instead of dispatching "delete" to enable pending status.
     */
    export let deletionConfirmed = async (
        password: string,
    ): Promise<void> => {};
    export let description = "";
    export let warningText = "";
    export let deleteBtnText = "Delete";
    export let confirmDeletionWithEmail = false;

    let pendingDelete = false;
    let clickedDelete = false;
    let password = "";
    let requestFailed = false;

    async function handleDeletionConfirmed() {
        pendingDelete = true;
        clickedDelete = true;
        requestFailed = false;
        try {
            await deletionConfirmed(password);
            pendingDelete = false;
        } catch (error) {
            requestFailed = true;
            pendingDelete = false;
        }
    }
</script>

<div class="delete">
    <h2 class="delete-header">
        Danger Zone
        <div class="delete-header__flames">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z"
                />
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.974 5.974 0 01-2.133-1A3.75 3.75 0 0012 18z"
                />
            </svg>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z"
                />
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.974 5.974 0 01-2.133-1A3.75 3.75 0 0012 18z"
                />
            </svg>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z"
                />
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.974 5.974 0 01-2.133-1A3.75 3.75 0 0012 18z"
                />
            </svg>
        </div>
    </h2>
    <p class="delete-text">{@html description}</p>
    {#if !clickedDelete}
        {#if confirmDeletionWithEmail}
            <a
                class="subtle-delete-button"
                on:click={() => (clickedDelete = true)}
                href={"#"}
            >
                <SVGIcon name="close-circle" size={16} height={16} />
                {@html deleteBtnText}
            </a>
        {:else}
            <button
                class="delete-button"
                on:click={() => (clickedDelete = true)}
                >{@html deleteBtnText}</button
            >
        {/if}
    {:else if pendingDelete}
        <button class="delete-button delete-button--cancel" disabled
            >Pending delete...</button
        >
    {:else}
        <p class="delete-text">{@html warningText}</p>
        {#if confirmDeletionWithEmail}
            <p class="delete-text">If so, type your password to confirm.</p>
            <div class="input-group">
                <div class="input-wrapper" class:input--warning={requestFailed}>
                    <input
                        type="password"
                        class="form-input"
                        placeholder="Password"
                        bind:value={password}
                    />
                </div>
                {#if requestFailed}
                    <span class="error-message"> Incorrect password </span>
                {/if}
            </div>
        {/if}
        <button
            class="delete-button"
            disabled={confirmDeletionWithEmail && password === ""}
            on:click={handleDeletionConfirmed}
        >
            Yes, delete it
        </button>
        <button
            class="delete-button delete-button--cancel"
            on:click={() => (clickedDelete = false)}>Cancel</button
        >
    {/if}
</div>

<style>
    @import "../../../main.css";

    .delete {
        @apply flex flex-col gap-2 !important;
    }

    .delete-header {
        @apply reset flex flex-row items-center gap-2 !important;
    }

    .delete-header__flames {
        @apply flex flex-row text-gray-400 !important;
    }

    .delete-header__flames svg {
        @apply h-4 w-4 !important;
    }

    .delete-text {
        @apply text-sm !important;
    }

    .delete-button {
        @apply rounded-full bg-pink-600 p-2 text-white transition-all hover:bg-rose-700 !important;
    }

    .delete-button--cancel {
        @apply bg-gray-200 text-black hover:bg-gray-300 !important;
    }

    .subtle-delete-button {
        @apply flex flex-row items-center justify-start gap-1 text-sm text-pink-600;
    }

    .input-group {
        @apply reset flex flex-shrink-0 flex-col gap-1 !important;
    }

    .input-wrapper {
        @apply flex flex-row items-center gap-1 rounded-full border border-gray-200 bg-white p-4 !important;
    }

    .form-input {
        @apply w-full text-sm outline-none !important;
    }

    .delete-button:disabled {
        @apply cursor-default bg-gray-200 text-gray-300 hover:bg-gray-200 !important;
    }

    .error-message {
        @apply mx-6 text-xs text-pink-500 !important;
    }

    .input--warning {
        @apply border-pink-500 !important;
    }
</style>
